

/*function report( getReportValueFn, reportFn){
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                let reportVal = getReportValueFn.call(this)
                reportFn(reportVal)

                return targetFunction.call(this, ...arg)
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}*/


/**
 * 装饰器-负责上报
 *
 * @reportListOrgetReportValueFn 上报参数，接受的参数格式有如下几种：
 * {
 *      value: '' || function(){},
 *      action: reportFunction
 * }
 *
 * {
 *      key: '',
 *      value: '' || function(){},
 *      action: reportFunction
 * }
 *
 * {
 *      targetSelector: '#id.class',
 *      eventName: 'click',
 *      params: function(){},
 *      action: reportFunction(e, params)
 * }
 *
 */
export function report( reportListOrgetReportValueFn, reportFn){
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                /*let reportVal = getReportValueFn.call(this)
                reportFn(reportVal)
                return targetFunction.call(this, ...arg)*/
                if(Array.isArray(reportListOrgetReportValueFn)){
                    let reportList = reportListOrgetReportValueFn
                    reportList.forEach(report=>{
                        let args = []
                        const {key, value, targetSelector, eventName, action, params, condition } = report
                        let reportCondition = true
                        if(typeof condition === 'function'){
                            reportCondition = condition.call(this)
                        }
                        if(!!reportCondition){
                            if(key || value){
                                value && args.push('function'===typeof value ? value.call(this) : value)
                                key && args.push(key)
                                // console.log('上报参数====>', args, key, value)
                                action.apply(this, args)
                            }else if(!key && !value && !(targetSelector && eventName)){
                                action.apply(this)
                            }else if(targetSelector && eventName){
                                const targetEl = document.querySelector(targetSelector)
                                console.log('上报参数-click ====>', targetEl, targetSelector, eventName)
                                targetEl && targetEl.addEventListener(eventName, (e)=> {
                                    //const target = e.target || e.srcElement || e.currentTarget
                                    console.log('do ------- 点击上报',e)
                                    //console.log('do ------- container',proxySelector,targetSelector, targetEl.classList, this)
                                    // let _params = params&&params.call(this) || {} 、、
                                    // params是对象应该不能用call调用（捂脸），这里暂时注释掉
                                    action.call(this, e, params);
                                }, false)
                            }
                        }
                    })
                }
                return targetFunction.call(this, ...arg)
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}


/**
 * 用于兼容有问题sdk
 * @param checkFn 检查需要被兼容处理的sdk版本方法 返回true为需要兼容，false不需要兼容
 * @param compatibleObject 兼容处理对象
 * @returns {Function}
 */
export function compatible(checkFn, compatibleObject){
    let decoratorObj = null
    return function(target, name, descriptor){
        let targetFunction = descriptor.value
        if ('function' === typeof targetFunction) {
            descriptor.value = function (...arg) {
                //如果sdkVersion为要兼容的版本 调用兼容方法compatibleFn
                if(checkFn()){
                    !decoratorObj && (decoratorObj = new compatibleObject())
                    return decoratorObj[targetFunction.name].call(this, ...arg)
                }else{
                    //如果sdkVersion为不需要兼容的版本 调用原本的方法
                    return targetFunction.call(this, ...arg)
                }
            }
        } else {
            console.warn('装饰对象错误')
        }
    }
}